<template>
  <section class="container-full-5">

    <div class="bg-carte p-5">
      <div class="s20">

      <!-- Cartes recto + verso côte à côte -->
      <div class="flex gap-5">
        <div class="s10_mobile">
          <!--CardCarte Recto-->
          <div class="card-carte" v-if="selectedCarte">
            <div class="card-carte-floating">
              <div class="s20">
                <h5 class="secondary-font font-bold mb-3">Solde utilisable</h5>
                <div class="flex align-items-center gap-2">
                  <h1 class="secondary-font text-6xl">{{ showBalance ? formatAmount(selectedCarte.solde) : '*** ***' }}</h1>
                  <h2 class="secondary-font text-4xl mt-2">F</h2>
                  <div class="mt-2 ml-2 cursor-pointer" @click="showBalance = !showBalance">
                    <img src="/public/icons/icon-eye-off.svg" class="size-medium icon-white" alt="" />
                  </div>
                </div>
                <div class="card-carte-floating-bottom">
                  <h5 class="s10 secondary-font font-bold">{{ selectedCarte.numeroMasque || '' }}</h5>
                  <div class="s10 flex-right align-items-center gap-2">
                    <img src="/public/icons/icon-edit.svg" class="size-medium icon-white" alt="" />
                    <h5 class="secondary-font font-bold">{{ selectedCarte.alias || selectedCarte.type || 'Carte' }}</h5>
                  </div>
                </div>
              </div>
            </div>
            <img src="/public/images/carte_coop_light.png" class="card-carte-img" alt="Carte" />
          </div>
          <!-- Pas de carte -->
          <div class="card-carte" v-else-if="!loading && cartes.length === 0" style="opacity: 0.3;">
            <div class="card-carte-floating">
              <div class="s20">
                <h5 class="secondary-font font-bold mb-3">Solde utilisable</h5>
                <div class="flex align-items-center gap-2">
                  <h1 class="secondary-font text-6xl">0</h1>
                  <h2 class="secondary-font text-4xl mt-2">F</h2>
                </div>
                <div class="card-carte-floating-bottom">
                  <h5 class="s10 secondary-font font-bold">Aucune carte</h5>
                </div>
              </div>
            </div>
            <img src="/public/images/carte_coop_light.png" class="card-carte-img" alt="" />
          </div>
        </div>

        <div class="s10_mobile">
          <!--CardCarte Verso-->
          <div class="card-carte-verso" v-if="selectedCarte">
            <div class="card-carte-floating right-bottom"></div>
            <img src="/public/images/carte_coop_verso.png" class="card-carte-img" alt="Carte verso" />
          </div>
        </div>
      </div>

      <!-- Boutons d'action sous les cartes -->
      <div class="flex-center gap-5 mt-5">
        <button class="btn-supra lg black flex-center flex-col align-items-center opacity-3" disabled>
          <div class="btn-supra-show-set btn-supra-animate mb-3">
            <div class="btn-supra-show px-2">
              <img src="/public/icons/icon-scan.svg" class="btn-supra-icon icon-white" alt="" />
            </div>
          </div>
          <span class="text-grey-700">Scanner</span>
        </button>

        <button class="btn-supra lg black flex-center flex-col align-items-center opacity-3" disabled>
          <div class="btn-supra-show-set btn-supra-animate mb-3">
            <div class="btn-supra-show px-2">
              <img src="/public/icons/icon-recharger.svg" class="btn-supra-icon icon-white" alt="" />
            </div>
          </div>
          <span class="text-grey-700">Recharger</span>
        </button>

        <button class="btn-supra lg black flex-center flex-col align-items-center opacity-3" disabled>
          <div class="btn-supra-show-set btn-supra-animate mb-3">
            <div class="btn-supra-show">
              <img src="/public/icons/icon-souscription.svg" class="btn-supra-icon icon-white" alt="" />
            </div>
          </div>
          <span class="text-grey-700">Répartition</span>
        </button>

        <button class="btn-supra lg black flex-center flex-col align-items-center">
          <div class="btn-supra-show-set btn-supra-animate mb-3">
            <div class="btn-supra-show">
              <img src="/public/icons/icon-verrouillage.svg" class="btn-supra-icon icon-white" alt="" />
            </div>
          </div>
          <span class="text-grey-700">{{ selectedCarte?.statut === 'blocked' ? 'Verrouillée' : 'Verrouiller' }}</span>
        </button>
      </div>

      <hr class="hr mt-6 mb-6 opacity-1" />
      <div class="clear-both h-0">&nbsp;</div>

      <!-- Solde utilisé et catégories - à l'intérieur de bg-carte -->
      <div v-if="selectedMois">
        <div class="s11_mobile flex-center gap-5">
          <!-- Graphique Doughnut -->
          <div class="w-35 px-1">
            <Doughnut :data="doughnutData" :options="doughnutOptions" />
          </div>
          <!-- Stats -->
          <div class="w-65">
            <h4 class="secondary-font font-semibold text-grey-600 mb-2">Solde utilisé</h4>
            <h2 class="secondary-font font-semibold text-grey-700 mb-2">{{ moisLabel(selectedMois.mois) }} {{ selectedMois.annee }}</h2>
            <h1 class="secondary-font font-semibold text-grey-800 mb-2">{{ formatAmount(soldeUtilise) }} F CFA</h1>
          </div>
        </div>

        <!-- Barres de catégories -->
        <div class="s9_mobile">
          <div
            v-for="(cat, idx) in selectedMois.stat"
            :key="idx"
          >
            <div class="h-20 rounded-100 position-relative" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
              <div class="widget-floating px-5 py-0 flex-left">
                <div class="w-50 text-sm">{{ categorieLabel(cat.categorie_slug) }} &nbsp; {{ Math.round(cat.pourcentage) }}%</div>
                <div class="w-50 text-sm text-right font-bold">{{ formatAmount(cat.total) }} F</div>
              </div>
              <div
                class="h-100p flex align-items-center justify-content-right rounded-100 text-lg text-white"
                :style="{ width: cat.pourcentage + '%', backgroundColor: getCategorieColor(cat.categorie_slug) }"
              ></div>
            </div>
            <div class="clear-both h-7">&nbsp;</div>
          </div>
        </div>
      </div>

      </div><!-- /s20 -->
    </div><!-- /bg-carte -->

    <!-- Sélecteur de carte si plusieurs -->
    <div v-if="cartes.length > 1" class="flex-center gap-3 mt-4">
      <span
        v-for="(carte, idx) in cartes"
        :key="carte.id"
        class="btn sm"
        :class="selectedCarteIndex === idx ? 'light2' : 'light'"
        @click="selectCarte(idx)"
      >
        {{ carte.alias || carte.bloc4 }}
      </span>
    </div>

    <div class="clear-both h-20">&nbsp;</div>

    <!-- Filtre par mois -->
    <div v-if="moisData.length > 0" class="s20 flex gap-3 mb-6">
      <span
        v-for="(m, idx) in moisData"
        :key="idx"
        class="btn sm cursor-pointer"
        :class="selectedMoisIndex === idx ? 'light2' : 'light'"
        @click="selectedMoisIndex = idx"
      >
        {{ moisLabel(m.mois) }}
      </span>
    </div>

    <!-- Transactions -->
    <div class="s20" v-if="selectedMois">
      <div
        v-for="tx in selectedMois.transactions"
        :key="tx.id"
        class="flex gap-6 mb-4"
      >
        <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
          <img src="/public/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" alt="" />
        </div>
        <div class="s13 mt-2">
          <h6 class="secondary-font font-semibold mb-1">{{ tx.libelle }}</h6>
          <p class="secondary-font font-semibold text-sm text-grey-600 mb-2">
            {{ formatDateTransaction(tx.date) }} - {{ tx.reference }}
          </p>
        </div>
        <h5 class="s5 secondary-font text-right mt-2" :class="tx.type === 'credit' ? 'text-green' : ''">
          {{ tx.type === 'credit' ? '+' : '-' }}{{ formatAmount(tx.montant) }} F
        </h5>
      </div>

      <div v-if="selectedMois.transactions.length === 0" class="text-grey-600 mb-4">
        Aucune transaction pour ce mois
      </div>
    </div>

    <div v-if="loading" class="flex-center py-7">
      <p class="secondary-font text-grey-600">Chargement...</p>
    </div>

    <div class="clear-both h-60"></div>

  </section>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue'
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import carteService, { type Carte, type CarteMoisData } from '@/services/carteService'
import { useCarteStore } from '@/stores/carte.store'
import { formatAmount } from '@/utils/formatters'

ChartJS.register(ArcElement, Tooltip, Legend)

const MOIS_NOMS = [
  '', 'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
]

const CATEGORIE_LABELS: Record<string, string> = {
  supermarche: 'Achat Supermarché',
  divertissement: 'Divertissement',
  market: 'Achat Market',
  sante: 'Santé',
  recharger: 'Recharge',
  retirer: 'Retrait',
  general: 'Général'
}

const CATEGORIE_COLORS: Record<string, string> = {
  market: '#00B9AC',
  sante: '#58D9F1',
  supermarche: '#FF9E00',
  recharger: '#2ECC71',
  retirer: '#27AE60',
  divertissement: '#D00EF5',
  general: '#34C759'
}

export default defineComponent({
  name: 'FrontofficeCarte',
  components: { Doughnut },
  setup() {
    const loading = ref(true)
    const cartes = ref<Carte[]>([])
    const selectedCarteIndex = ref(0)
    const moisData = ref<CarteMoisData[]>([])
    const selectedMoisIndex = ref(0)
    const showBalance = ref(true)

    const selectedCarte = computed(() => cartes.value[selectedCarteIndex.value] || null)
    const selectedMois = computed(() => moisData.value[selectedMoisIndex.value] || null)

    const soldeUtilise = computed(() => {
      const mois = selectedMois.value
      if (!mois?.stat?.length) return 0
      return mois.stat.reduce((sum, s) => sum + (s.total || 0), 0)
    })

    function moisLabel(mois: number): string {
      return MOIS_NOMS[mois] || ''
    }

    function categorieLabel(slug: string): string {
      return CATEGORIE_LABELS[slug] || slug
    }

    function getCategorieColor(slug: string): string {
      return CATEGORIE_COLORS[slug] || '#34C759'
    }

    function formatDateTransaction(dateStr: string): string {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      if (isNaN(date.getTime())) return '-'
      const jour = date.getDate().toString().padStart(2, '0')
      const mois = MOIS_NOMS[date.getMonth() + 1]?.substring(0, 3) || ''
      const annee = date.getFullYear()
      const heures = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      return `${jour} ${mois} ${annee} ${heures}:${minutes}`
    }

    async function loadCartes() {
      loading.value = true
      try {
        const carteStore = useCarteStore()
        const cachedCartes = await carteStore.fetchCartes()
        cartes.value = cachedCartes
        if (cartes.value.length > 0) {
          await loadCarteDetail(cartes.value[0].id)
        }
      } catch (e) {
        // silencieux
      } finally {
        loading.value = false
      }
    }

    async function loadCarteDetail(carteId: number) {
      try {
        const res = await carteService.getCarte(carteId)
        if (res.data) {
          moisData.value = res.data.data || []
          selectedMoisIndex.value = 0
        }
      } catch (e) {
        // silencieux
      }
    }

    function selectCarte(index: number) {
      selectedCarteIndex.value = index
      const carte = cartes.value[index]
      if (carte) {
        loadCarteDetail(carte.id)
      }
    }

    const doughnutData = computed(() => {
      const mois = selectedMois.value
      if (!mois?.stat?.length) {
        return {
          labels: ['Aucune donnée'],
          datasets: [{ data: [1], backgroundColor: ['#e0e0e0'], borderWidth: 0 }]
        }
      }
      return {
        labels: mois.stat.map(s => categorieLabel(s.categorie_slug)),
        datasets: [{
          data: mois.stat.map(s => s.pourcentage),
          backgroundColor: mois.stat.map(s => CATEGORIE_COLORS[s.categorie_slug] || '#34C759'),
          borderWidth: 2,
          borderColor: '#ffffff'
        }]
      }
    })

    const doughnutOptions = {
      responsive: true,
      maintainAspectRatio: true,
      cutout: '65%',
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            label: (ctx: any) => {
              const mois = selectedMois.value
              if (!mois?.stat?.length) return ''
              const stat = mois.stat[ctx.dataIndex]
              return `${categorieLabel(stat.categorie_slug)}: ${formatAmount(stat.total)} F (${Math.round(stat.pourcentage)}%)`
            }
          }
        }
      }
    }

    onMounted(() => {
      loadCartes()
    })

    return {
      loading,
      cartes,
      selectedCarteIndex,
      selectedCarte,
      moisData,
      selectedMoisIndex,
      selectedMois,
      soldeUtilise,
      showBalance,
      formatAmount,
      moisLabel,
      categorieLabel,
      formatDateTransaction,
      selectCarte,
      getCategorieColor,
      doughnutData,
      doughnutOptions
    }
  }
})
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
